import { Component, ChangeDetectorRef } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from "@angular/router";
import { LocationStrategy } from '@angular/common';
import { ConfigService } from './config.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'B2B';

  idleState = "NOT_STARTED";
  timedOut = false;
  countdown?: number = null;
  lastPing?: Date = null;
  mcountdown: number;
  math = Math;

  constructor(private configService: ConfigService, private Location: LocationStrategy, private idle: Idle, private keepalive: Keepalive, cd: ChangeDetectorRef, private router: Router) {
    //NEW WORK 3-10-2022 NG IDLE WORK MINUTES CHANGE
    this.idle.setIdle(3600); // how long can they be inactive before considered idle, in seconds
    this.idle.setTimeout(120); // how long can they be idle before considered timed out, in seconds
    //END NEW WORK 3-10-2022 NG IDLE WORK

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      if (this.router.url !== '/') {
        document.querySelector(".new-class-for-body").classList.add("main-body-warn");
        document.getElementById("main_Warn").style.display = "block";
        this.idleState = 'You\'ve gone idle!';
      }
    });

    this.idle.onIdleEnd.subscribe(() => {
      if (this.router.url !== '/') {
        this.idleState = 'No longer idle.';
        console.log(this.idleState);
        this.reset();
      }
    });

    this.idle.onTimeout.subscribe(() => {
      if (this.router.url !== '/') {
        localStorage.removeItem('_logged-in');
        this.idleState = 'Timed out!';
        this.timedOut = true;
        document.querySelector(".new-class-for-body").classList.remove("main-body-warn");
        document.getElementById("main_Warn").style.display = "none";
        this.router.navigateByUrl('');
      }
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      if (this.router.url !== '/') {
        this.mcountdown = countdown;
        this.idleState = 'You will time out in ' + countdown + ' seconds!';
      }
    });

    // set keepalive parameters, omit if not using keepalive
    this.keepalive.interval(15); // will ping at this interval while not idle, in seconds
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
  }

  get config(): any {
    return this.configService.getConfigData();
  }

  reset() {
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
    this.timedOut = false;
  }

  ngOnInit(): void {
    environment.baseUrl = this.config.baseUrl;
    environment.isPakistan = this.config.isPakistan;
    environment.backSystemBaseUrl = this.config.backSystemBaseUrl;
    environment.companyName = this.config.companyName;
    environment.androidPath = this.config.androidPath;
    environment.operatingCountry = this.config.operatingCountry;
    // right when the component initializes, start reset state and start watching
    this.reset();
  }

  LogoutClick() {
    if (this.router.url !== '/') {
      localStorage.removeItem("UserId");
      localStorage.removeItem("AgencyId");
      localStorage.removeItem("ParentAgency");
      localStorage.removeItem("ImmediateParent");
      document.querySelector(".new-class-for-body").classList.remove("main-body-warn");
      document.getElementById("main_Warn").style.display = "none";

      this.timedOut = true;

      this.router.navigateByUrl('');
    }
  }

  StayClick() {
    if (this.router.url !== '/') {
      document.querySelector(".new-class-for-body").classList.remove("main-body-warn");
      document.getElementById("main_Warn").style.display = "none";
      this.reset();
    }
  }
}
